// Import the data from people.json
export const dataJson = './people.json';
// Grabbing the container element
export const container = document.querySelector(".container");
export const inputSearchName = document.querySelector(".input");
export const filterByMonth = document.querySelector("#month");
export const formFilter = document.querySelector("form.new_list");